<template>
    <modal
        :name="'renovar-' + abonado.id"
        transition="pop-out"
        :width="1000"
        height="auto"
        :scrollable="true"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2>Renovación rápida</h2>
                    </div>
                    <div class="col-2">
                        <button type="button" class="close" @click.prevent="close()">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
            </div>
            <template v-if="paso === 1">
                <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                    <div class="card-body" v-if="(abonadoLocal.asiento) || abonadoLocal.plaza && plaza_disponible.libre">
                        <div class="row align-items-center">
                            <div class="col-3">
                                <p>NÚM. ABONADO ANTERIOR: <span class="text-primary h5">{{ abonadoLocal.n_abonado_antiguo }}</span></p>
                            </div>
                            <div class="col-3">
                                <p>NÚM. ABONADO NUEVO: <span class="text-primary h5">{{ abonadoLocal.n_abonado }}</span></p>
                            </div>
                            <div class="col-6">
                                <p v-if="abonadoLocal.asiento">
                                    ZONA:
                                    <br/>
                                    <span class="text-primary h5">{{ abonadoLocal.asiento.region }} / FILA: {{ abonadoLocal.asiento.row }} / BUTACA: {{ abonadoLocal.asiento.seat }}</span>
                                </p>
                                <p v-else-if="abonadoLocal.plaza">
                                    <span class="text-primary h5">
                                        {{ abonadoLocal.plaza.region_name ?? abonadoLocal.plaza.section_name }}</span> - FILA: <span class="text-primary h5 ">{{ abonadoLocal.plaza.fila }}</span> - ASIENTO: <span class="text-primary h5">{{ abonadoLocal.plaza.butaca }}
                                    </span>
                                </p>
                            </div>
                            <div class="col-12">
                                <strong>DATOS PERSONALES</strong>
                                <hr class="mt-1" />
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-4">
                                        <FormInput 
                                            label="Nombre" 
                                            name="nombre" 
                                            id="nombre" 
                                            rules="required" 
                                            v-model="abonadoLocal.name" 
                                        />
                                    </div>
                                    <div class="col-4">
                                        <FormInput 
                                            label="Apellidos" 
                                            name="apellidos" 
                                            id="apellidos" 
                                            rules="required" 
                                            v-model="abonadoLocal.surnames" 
                                        />
                                    </div>
                                    <div class="col-4">
                                        <FormInput 
                                            label="Dni" 
                                            name="dni" 
                                            id="dni" 
                                            rules="required" 
                                            v-model="abonadoLocal.dni" 
                                        />
                                    </div>
                                    <div class="col-4">
                                        <FormInput 
                                            label="Fecha de nacimiento" 
                                            name="fecha_nacimiento" 
                                            id="fecha_nacimiento" 
                                            rules="required" 
                                            type="date" 
                                            min="1900-01-01" 
                                            v-model="abonadoLocal.fecha_nacimiento" 
                                        />
                                    </div>
                                    <div class="col-4">
                                        <FormInput 
                                            label="Email" 
                                            name="email" 
                                            id="email" 
                                            rules="required" 
                                            v-model="abonadoLocal.email" 
                                        />
                                    </div>
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label>{{ $t('formularios.telefono') }}</label>
                                            <PhoneInput 
                                                :name="'telefono' + abonadoLocal.id" 
                                                :phone="abonadoLocal.telefono ?? null"
                                                :required="true" 
                                                @setNumber="(number) => { abonadoLocal.telefono = number;}"
                                                @validNumber="(valid) => { abonadoLocal.telefono_valido = valid;}"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <Paises
                                            @rellenarPais="rellenarPais"
                                            :errors="errors"
                                            v-on:selected="opt => { pais = opt; abonadoLocal.pais = opt.nombre;}"
                                        />
                                    </div>
                                    <div class="col-4">
                                        <Provincias
                                            :errors="errors" :pais="pais.id"
                                            :provincia="abonadoLocal.provincia ?? ''"
                                            v-on:selected="opt => { provincia = opt; abonadoLocal.provincia = opt.nombre; }"
                                        />
                                    </div>
                                    <div class="col-4">
                                        <Locations
                                            :desactivar="!provincia"
                                            :provincia="provincia"
                                            :errors="errors"
                                            :localidad="abonadoLocal.localidad ?? ''"
                                            v-on:selected="opt => { abonadoLocal.localidad = opt.nombre;}"
                                            :forceMultiselect="true"
                                        />
                                    </div>
                                    <div class="col-4 mt-3">
                                        <FormInput 
                                            label="Domicilio" 
                                            name="domicilio" 
                                            id="domicilio" 
                                            rules="required" 
                                            v-model="abonadoLocal.domicilio" 
                                        />
                                    </div>
                                    <template v-if="fields && fields.length > 0">
                                        <div v-for="(field, index) in fields" :key="index" :class="'col-4' + (field.type === 'textarea' ? ' col-lg-12' : '')">
                                            <FieldComponent 
                                                :field="field" 
                                                :desactivar="false" 
                                                v-model="abonadoLocal.properties[field.name]"
                                            />
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div class="col-12">
                                <strong>DATOS SOBRE EL ABONO</strong>
                                <hr class="mt-1" />
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label for="area">Tipo de abono</label>
                                            <ValidationProvider name="area" rules="required" v-slot="{ errors }">
                                                <select name="area" v-model="abonadoLocal.area" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')">
                                                    <option value="undefined" disabled hidden>Seleccione un tipo de abono</option>
                                                    <template v-for="(precio, index) in getPrecioAbonado(abonadoLocal)">
                                                        <option :key="index" :value="precio" v-if="precio.renovacion">{{ precio.descripcion }}<span v-if="precio.renovacion"> - (Renovación)</span></option>
                                                    </template>
                                                </select>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label for="precio">Precio</label>
                                            <ValidationProvider name="precio" rules="required" v-slot="{ errors }">
                                                <select name="precio" v-model="abonadoLocal.precio" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')">
                                                    <option value="undefined" disabled hidden>Seleccione un precio</option>
                                                    <option v-for="(descuento, index) in precios_abono" :key="index" :value="descuento">{{ descuento.label }}</option>
                                                </select>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label for="metodo_pago">Método de pago</label>
                                            <ValidationProvider name="metodo_pago" rules="required" v-slot="{ errors }">
                                                <select :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" name="metodo_pago" v-model="abonadoLocal.metodo_pago">
                                                    <option value="undefined" disabled hidden>Seleccione un método de pago</option>
                                                    <option v-for="(metodo, index) in metodos_pago" :key="index" :value="metodo">{{ metodo.nombre }}</option>
                                                </select>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="col-4" v-if="permisos['venta.descuento']">
                                        <div class="form-group">
                                            <label for="descuento">Descuento en %</label>
                                            <ValidationProvider name="descuento_total" rules="required" v-slot="{ errors }">
                                                <select :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" name="descuento" v-model="abonadoLocal.descuento_aplicado" @change="aplicadoDescuento('porcentaje')" :disabled="disabled_descuento_porcentaje">
                                                    <option value="0">Sin descuento</option>
                                                    <option v-for="(descuento, index) in configuracion.descuento_aplicado" :key="index" :value="descuento.valor">{{ descuento.label }}</option>
                                                </select>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="col-4" v-if="permisos['venta.descuento']">
                                        <div class="form-group">
                                            <label for="nombre">Descuento en €</label>
                                            <ValidationProvider name="descuento en €" rules="required|double" v-slot="{ errors }">
                                                <input type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Descuento en €" v-model="abonadoLocal.descuento_integro" @input="aplicadoDescuento('integro')" :disabled="disabled_descuento_integro" />
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <FormInput label="Peña" id="penista" v-model="abonadoLocal.penista" />
                                    </div>
                                    <div class="col-4">
                                        <FormInput label="Empresa" id="empresa" v-model="abonadoLocal.empresa" />
                                    </div>
                                    <div v-if="is_domiciliado == true" class="col-4">
                                        <FormInput label="IBAN" id="iban" rules="required" v-model="abonadoLocal.iban" />
                                    </div>
                                    <div v-if="is_domiciliado == true" class="col-4">
                                        <FormInput label="Titular de la cuenta" id="titular_cuenta" rules="required" v-model="abonadoLocal.titular_cuenta" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="observaciones">Observaciones</label>
                                    <textarea class="form-control" rows="3" placeholder="Observaciones..." v-model="abonadoLocal.observaciones"></textarea>
                                </div>
                            </div>
                            <div class="col-12" v-if="abonadoLocal.metodo_pago && abonadoLocal.metodo_pago.id == 9">
                                <FormInput label="IBAN" name="IBAN" rules="required" v-model="abonadoLocal.iban" />
                                <FormInput label="Titular de la cuenta" name="Titular de la cuenta" rules="required" v-model="abonadoLocal.titular_cuenta" />
                            </div>

                            <div v-if="listaAbonados.renovacion_automatica" >
                                <checkBoxRenovacion 
                                    :identificador="abonadoLocal.id"
                                    v-model="abonadoLocal.renovacion_automatica"
                                />
                            </div>

                            <div>
                                <DatosLegales 
                                    :datos="abonado" 
                                    :font_size="'16'" 
                                    :text_align="'left'" 
                                    :disabled="true" 
                                />
                            </div>
                            <div class="col-12">
                                <Button type="submit">Renovar</Button>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="abonadoLocal.plaza && !plaza_disponible.libre">
                        <div class="alert alert-danger w-75 mx-auto my-3 d-flex align-items-center justify-content-between" role="alert">
                            {{ plaza_disponible.message }}
                            <Button @click="cambiarAsiento">Cambiar asiento</Button>
                        </div>
                    </div>
                </ValidationObserver>
                <div class="card-footer text-right">
                    <Button type="button" name="button" @click.prevent="close()">CERRAR</Button>
                </div>
            </template>
            <template v-if="paso === 2">
                <SeleccionarParcelasComponent
                    @continuar="(cart_id, datosParcelasseleccionados) => {
                        if(cart_id) {
                            parcelas_session_id = cart_id
                            datosParcelas = datosParcelasseleccionados;
                        };
                        paso = 3;
                    }"
                />
            </template>
            <template v-if="paso === 3">
                <div class="card-body">
                    <div class="row">
                        <div class="col-6">
                            <div class="row">
                                <div class="col-12">
                                    <strong>DATOS DEL ABONO</strong>
                                </div>
                                <div class="col-12">
                                    <span class="h5"><span class="text-primary"><i class="fas fa-user"></i></span> <strong> {{ abonadoLocal.name }} {{ abonadoLocal.surnames }}</strong></span>
                                    <hr/>
                                </div>
                                <div class="col-12">
                                    <span class="h5"><span class="text-primary"><i class="fas fa-id-card"></i></span> <strong> {{ abonadoLocal.dni }}</strong></span>
                                    <hr/>
                                </div>
                                <div class="col-12">
                                    <span class="h5"><span class="text-primary"><i class="fas fa-envelope"></i></span> <strong> {{ abonadoLocal.email }}</strong></span>
                                    <hr/>
                                </div>

                                <div class="col-12">
                                    <span class="h5"><span class="text-primary"><i class="fas fa-phone"></i></span> <strong> {{ abonadoLocal.telefono }}</strong></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="row">
                                <div class="col-12">
                                    <strong>INFORMACIÓN DEL ABONO</strong>
                                </div>
                                <div class="col-12">
                                    <template v-if="abonadoLocal.asiento">
                                        <span class="h4 text-uppercase text-primary"><strong>{{ abonadoLocal.asiento.region }}</strong></span>
                                        <span class="h4 text-uppercase"><strong>/ FILA: {{ abonadoLocal.asiento.row }}</strong></span>
                                        <span class="h4 text-uppercase"><strong>/ BUTACA: {{ abonadoLocal.asiento.seat }}</strong></span>                                            
                                    </template>
                                    <template v-else-if="abonadoLocal.plaza">
                                        <span class="h4 text-uppercase" v-if="abonadoLocal.plaza.region_name">{{ abonadoLocal.plaza.region_name }}</span>
                                        <span class="h4 text-uppercase"> / FILA: {{ abonadoLocal.plaza.fila }}</span>
                                        <span class="h4 text-uppercase"> / BUTACA: {{ abonadoLocal.plaza.butaca }}</span>
                                    </template>
                                </div>
                                <div class="col-12 mt-3">
                                    <strong>TIPO DE ABONO</strong>
                                </div>
                                <div class="col-12">
                                    <span class="h4 text-uppercase"><strong>{{ abonadoLocal.precio.descripcion }}</strong></span>
                                </div>
                                <div class="col-12 mt-3">
                                    <strong>FORMA DE PAGO SELECCIONADA</strong>
                                </div>
                                <div class="col-12">
                                    <span class="h4 text-uppercase"><strong>{{ abonadoLocal.metodo_pago.nombre }}</strong></span>
                                </div>
                                <div class="col-12 mt-3">
                                    <template v-if="! abonadoLocal.plazos">
                                        <strong>PRECIO ABONO <span> <span v-if="abonadoLocal.descuento_aplicado > 0" class="text-primary">(DESCUENTO DEL {{ abonadoLocal.descuento_aplicado }}%)</span></span></strong>
                                    </template>
                                    <template v-else>
                                        <div class="col-12 mt-3">
                                            <strong>PLAZOS:</strong>
                                        </div>
                                        <div class="col-12">
                                            <ul>
                                                <li v-for="(plazo, key) in abonadoLocal.plazos_pendientes" :key="key">
                                                    <template v-if="plazo.gastos_internos == 0">
                                                        Plazo: {{ ++key }} <span v-if="plazo.informacion">({{ plazo.informacion }})</span> - {{ plazo.importe + plazo.gastos  | formatear_precio }}
                                                    </template>
                                                    <template v-else>
                                                        Plazo: {{ ++key }} <span v-if="plazo.informacion">({{ plazo.informacion }})</span> - {{ plazo.importe  | formatear_precio }}
                                                    </template>                                            
                                                </li>                               
                                            </ul>
                                        </div>
                                    </template>
                                </div>
                                <div class="col-12">
                                    <span class="h4"><strike><strong v-if="abonadoLocal.descuento_aplicado > 0">{{ abonadoLocal.precio.precio_total_taquilla | formatear_precio }}</strong></strike></span>
                                    <template v-if="! abonadoLocal.plazos">
                                        <strong>TOTAL:</strong><span class="h1"> <del v-if="totalSinDescuentoMonedero">{{totalSinDescuentoMonedero | formatear_precio}}</del> <strong> {{ total | formatear_precio }}</strong></span>
                                    </template>
                                    <template v-else>
                                        <strong>TOTAL:</strong><span class="h1"><del class="" v-if="totalSinDescuentoMonedero">{{totalSinDescuentoMonedero | formatear_precio}}</del> <strong> {{ total | formatear_precio }}</strong></span>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <hr/>
                        </div>

                        <div v-for="(parcela, index) in datosParcelas" :key="parcela.id" class="col-12 bg-light p-2 m-3">
                            <h3>
                                <strong class="d-flex align-items-center">
                                    <span class="text-primary pr-4">PARCELA {{ ++index }}. </span>
                                    <span class="pr-4"><strong> Parcela Nº</strong> {{ parcela.numero }} </span>
                                    <div class="pr-4">
                                        PRECIO: <span>{{ parseFloat(parcela.precioSeleccionado.precio + (!parcela.precioSeleccionado.price_management_interno ? parcela.precioSeleccionado.price_management : 0)) | formatear_precio }}</span>
                                    </div>
                                </strong>
                            </h3>
                        </div>

                        <div class="col-12" v-if="!loading && teatro.activar_referidos && abonadoLocal.importe_monedero > 0">
                            <Button class="float-left" @click.prevent="isDescuentoMonedero = !isDescuentoMonedero">Descuento monedero</Button>
                        </div>

                        <div class="col-12" v-if="!loading && teatro.activar_referidos && abonadoLocal.importe_monedero > 0">
                            <SaldoMonederoComponent
                                v-if="isDescuentoMonedero"
                                :saldo_disponible="abonadoLocal.importe_monedero"
                                :importe="total"
                                :descuento_aplicado="abonadoLocal.descuento_monedero === undefined ? 0 : parseFloat(abonadoLocal.descuento_monedero)"
                                @confirmado="descuentoConfirmado"
                                @cancelar="cancelarDescuento"
                            />
                        </div>

                        <div class="col-12" v-if="!loading">
                            <template v-if="! abonadoLocal.plazos">
                                <strong>TOTAL:</strong><span class="h1"><del v-if="totalSinDescuentoMonedero">{{totalSinDescuentoMonedero | formatear_precio}}</del> <strong> {{ total + importeTotalParcelas | formatear_precio }}</strong></span>
                            </template>
                            <template v-else>
                                <strong>TOTAL:</strong><span class="h1"><del v-if="totalSinDescuentoMonedero">{{totalSinDescuentoMonedero | formatear_precio}}</del> <strong> {{ total + importeTotalParcelas | formatear_precio }}</strong></span>
                            </template>

                            <template v-if="!finalizado">
                                <Button class="float-right" @click.prevent="finalizarCompra()">COMPRAR</Button>
                                <Button 
                                    class="float-right mr-3" 
                                    @click.prevent="() => {
                                        if(listaAbonados.activar_parcelas) {
                                            datosParcelas = null;
                                            borrarSesionParcelas(abonadoLocal.parcelas_session_id);
                                            paso = 2;
                                        } else {
                                            paso = 1;
                                        }
                                    }"
                                >
                                    EDITAR
                                </Button>
                            </template>
                            <template v-if="error">
                                <div class="alert alert-danger alert-dismissible mt-3">
                                    <h5><i class="icon fas fa-exclamation-triangle mt-2"></i>{{ error }}</h5>
                                </div>
                            </template>
                            <div class="alert alert-success alert-dismissible mt-3" v-if="finalizado && error == null">
                                <h5>
                                    <i class="icon fas fa-check mt-2"></i>
                                    {{ mensaje }}
                                    <Button :href="url_imprimir" class="btn-large float-right" target="_blank">Imprimir abono</Button>
                                    <Button :href="url_factura + '&tid=' + configuracion.hash_teatro" class="btn-large float-right mr-2" target="blank_">Imprimir recibo</Button>
                                    <Button v-if="url_parcelas" :href="url_parcelas" class="btn-large float-right mr-2" target="blank_">Imprimir parcelas</Button>
                                </h5>
                            </div>
                        </div>
                        <div v-else class="col-12" style="height: 100px">
                            <LoaderComponent />
                        </div>
                    </div>
                </div>
                <div class="card-footer text-right">
                    <Button type="button" name="button" @click.prevent="close()">CERRAR</Button>
                </div>
            </template>
        </div>
    </modal>
</template>

<script>
    import SaldoMonederoComponent from '../../../frontend/abonos/nuevo/SaldoMonederoComponent.vue';
    import DatosLegales from './DatosLegales.vue';
    import FieldComponent from '@/components/common/FieldComponent';
    import SeleccionarParcelasComponent from '../../abonos/renovacion/rapida/SeleccionarParcelasComponent.vue';
    import PhoneInput from '@/components/common/PhoneInput.vue';
    import Paises from "../../../common/forms/Paises";
    import Provincias from "../../../common/forms/Provincias";
    import Locations from "../../../common/forms/Locations";
    import checkBoxRenovacion from '../../../common/checkBoxRenovacion.vue';

    export default {
        props: {
            abonado: {
                type: Object,
                required: true
            },
            precios: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                metodos_pago: null,
                continuar: false,
                finalizado: false,
                loading: false,
                url_imprimir: null,
                url_factura: null,
                url_parcelas: null,
                mensaje: null,
                error: null,
                isDescuentoMonedero: false,
                total: 0,
                totalSinDescuentoMonedero: 0,
                preciosFiltered: null,
                abonadoLocal: {...this.abonado},
                paso: 1,
                datosParcelas: null,
                parcelas_session_id: null,
                disabled_descuento_integro: false,
                disabled_descuento_porcentaje: false,
                pais: null,
                provincia: null,
                errors: [],
            }
        },
        created() {
            this.pais = {id:0};
            this.abonadoLocal.properties = {};
            this.metodos_pago = this.teatro.metodos_pago_abonos_bases.slice();

            if (this.abonadoLocal.asiento) {
                this.preciosFiltered = this.precios.filter(precio => precio.renovacion);
                this.preciosFiltered = this.preciosFiltered.filter(precio => {
                    if (precio.zonas_ids.length > 0) {
                        return precio.zonas_ids.includes(this.abonadoLocal.asiento.region_id);                    
                    } return false;
                })
            } else if (this.abonadoLocal.plaza) {
                if (this.abonadoLocal.plaza.precios.length > 0) {
                    const preciosRenovacion = this.abonadoLocal.plaza.precios.filter(precio => precio.renovacion)
                    this.preciosFiltered = preciosRenovacion.map(precio => {
                        if (precio.descuentos.length > 0) {
                            precio.descuentos = precio.descuentos.map(descuento => {
                                descuento.label =
                                    `${descuento.descripcion} - (${descuento.price_management_interno_taquilla ? descuento.precio : descuento.precio + descuento.price_management_taquilla}€)`
                                return descuento
                            });
                            return precio;
                        }
                    });
                }
            }

            if (this.preciosFiltered && this.preciosFiltered.length === 1) {
                this.abonadoLocal.area = this.preciosFiltered[0];

                if (this.abonadoLocal.area.descuentos && this.abonadoLocal.area.descuentos.length === 1) {
                    this.abonadoLocal.precio = this.abonadoLocal.area.descuentos[0];
                }
            }

            this.abonadoLocal.descuento_aplicado = 0;
            this.abonadoLocal.descuento_integro = 0;

            this.borrarMetodoDePago(this.metodos_pago, 5);
            this.borrarMetodoDePago(this.metodos_pago, 8);
            this.borrarMetodoDePago(this.metodos_pago, 9);
        },
        computed: {
            lista_id() {
                return this.$store.getters.getListaId;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            precios_abono() {
                return this.abonadoLocal.area ? this.abonadoLocal.area.descuentos : [];
            },
            is_domiciliado() {
                if (!this.abonadoLocal.metodo_pago) {
                    return false
                }
                return this.abonadoLocal.metodo_pago.id == 5 ? true : false;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            permisos() {
                return this.$store.getters.getPermisos;
            },
            plaza_disponible() {
                if(this.abonadoLocal.plaza) {
                    const response = {
                        libre: false,
                        message: ''
                    }
        
                    if (!this.abonadoLocal.plaza.libre) {
                        const ocupada = this.abonadoLocal.plaza.ocupada;
        
                        if (this.abonadoLocal.plaza.info_ocupada.numero_abonado === this.abonadoLocal.n_abonado) {
                            response.libre = true;
                        } else {
                            response.message = 'Butaca ocupada por otro usuario';
                        }
        
                        if (ocupada.sesion) {
                            response.message = 'Butaca en sesión';
                        } else if (ocupada.evento_venta) {
                            response.message = 'Butaca vendida en un evento';
                        } else if (ocupada.evento_bloqueo) {
                            response.message = 'Butaca bloqueada en un evento';
                        } else if (ocupada.evento_sesion) {
                            response.message = 'Butaca en sesión en un evento';
                        }
                    } else {
                        response.libre = true;
                    }
        
                    return response;
                }

                return {
                    libre: false
                };
            },
            fields() {
                return this.$store.getters.getListaAbonados.fields;
            },
            listaAbonados() {
                return this.$store.getters.getListaAbonados;
            },
            importeTotalParcelas() {
                if(! this.datosParcelas || !this.datosParcelas.length) {
                    return 0;
                }

                let total = 0;

                this.datosParcelas.forEach(parcela => {
                    total += parcela.precioSeleccionado.precio;

                    if(! parcela.precioSeleccionado.price_management_interno) {
                        total += parcela.precioSeleccionado.price_management;
                    }
                });

                return total;
            },
        },
        methods: {
            getPrecioAbonado(abonado){
                if (abonado.penista) {
                    var precios = this.preciosFiltered.filter(precio => precio.exclusivo_penista);
                    if (precios.length > 0) {
                        return precios;
                    } else {
                        return this.preciosFiltered;
                    }
                }
                return this.preciosFiltered.filter(precio => !precio.exclusivo_penista);
            },
            formatSeg(segundo) {
                const minutes = Math.floor(segundo / 60);
                const remainingSeconds = segundo % 60;
                return `Min: ${minutes} - Seg: ${remainingSeconds}`;
            },
            validarSegundos(segundos) {
                const params = {
                    lista_id: this.lista_id,
                    filters : {},
                    segundo_elegido: segundos
                };

                this.$store.dispatch(this.config.getVuexAlias('front.temporada.segundos.disponible'), params).then(res => {
                    this.$refs.observer.setErrors({ ['segundo_elegido']: [] });                
                }).catch(error => {
                    const errors = [];
                    errors['segundo_elegido'] = ['El segundo seleccionado no esta disponible'];
                    this.$refs.observer.setErrors(errors);
                });
            },
            volver() {
                this.paso -= 1;
            },
            close() {
                this.$emit('close', 'renovar-' + this.abonadoLocal.id);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid && this.abonadoLocal.telefono_valido) {
                    if(this.abonadoLocal.metodo_pago.id == 9) {
                        this.setPlazos();
                    } else {
                        this.resetPlazos();
                    }

                    if (!this.abonadoLocal.precio.precio_total_taquilla) {
                        const precio = this.abonadoLocal.precio
                        this.abonadoLocal.precio.precio_total_taquilla = precio.price_management_interno_taquilla ? precio.precio : precio.precio + precio.price_management_taquilla; 
                    }

                    this.totalConDescuento(this.abonadoLocal.precio.precio_total_taquilla, this.abonadoLocal.descuento_aplicado != 0 ? this.abonadoLocal.descuento_aplicado: this.abonadoLocal.descuento_integro);
                    if(this.listaAbonados.activar_parcelas) {
                        this.paso = 2;
                    } else {
                        this.paso = 3;
                    }
                }
            },
            setPlazos() {
                var plazos = [];
                this.abonadoLocal.plazos = true;

                var precio_reserva = 50;
                var numero_plazos = 2;
                var precio = this.abonadoLocal.precio.precio;

                plazos.push({
                    importe: precio_reserva,
                    gastos: this.abonadoLocal.precio.price_management_taquilla,
                    gastos_internos: this.abonadoLocal.precio.price_management_taquilla_interno,
                    pagado: 0,
                    fecha_pago: null,
                    informacion: 'Reserva de asiento'
                });

                var importe_restante = precio - precio_reserva;
                var importe_plazos = importe_restante / numero_plazos;

                var infos = ['5 Agosto', '6 Septiembre'];

                for (var i = 0; i < numero_plazos; i++) { 
                    plazos.push({
                        importe: importe_plazos,
                        gastos: 0,
                        gastos_internos: this.abonadoLocal.precio.price_management_taquilla_interno,
                        pagado: 0,
                        fecha_pago: null,
                        informacion: infos[i]
                    });
                }

                this.abonadoLocal.plazos_pendientes = plazos;
            },
            resetPlazos() {
                this.abonadoLocal.plazos = false;
                this.abonadoLocal.plazos_pendientes = [];
            },
            totalConDescuento(precio, descuento) {
                var desc = 0;
                if (this.abonadoLocal.descuento_aplicado != 0){
                    desc = (descuento / 100) * precio;
                }else {
                    desc = descuento;
                }
                this.total = precio - desc;
            },
            finalizarCompra() {
                this.loading = true;
                if (this.abonadoLocal.asiento) {
                    this.abonadoLocal.asiento.zona_id = this.abonadoLocal.asiento.region_id;
                    this.abonadoLocal.asiento.asiento = this.abonadoLocal.asiento.seat;
                    this.abonadoLocal.asiento.fila = this.abonadoLocal.asiento.row;                
                }

                const params = {
                    filters: {
                        abonado_id: this.abonadoLocal.id
                    },
                    data_abonado: this.abonadoLocal,
                    metodo_pago: {
                        id: this.abonadoLocal.metodo_pago.id
                    },
                    asiento: this.abonadoLocal.asiento,
                    abonado_id: this.abonadoLocal.id,
                    precio_lista_abonado: this.abonadoLocal.area,
                    descuento_edad: this.abonadoLocal.precio,
                    descuento_aplicado: {
                        valor: this.abonadoLocal.descuento_aplicado
                    },
                    descuento_monedero: this.abonadoLocal.descuento_monedero === undefined ? 0 : parseFloat(this.abonadoLocal.descuento_monedero),
                    descuento_integro: this.abonadoLocal.descuento_integro === undefined ? 0 : this.abonadoLocal.descuento_integro,
                    parcelas_session_id: this.parcelas_session_id
                };  

                this.$store.dispatch(this.config.getVuexAlias('back.abonados.renovar'), params).then(res => {
                    if (res.data.error) {
                        this.error = 'Error al renovar, por favor, revise los asientos';
                    } else {
                        this.finalizado = true;
                        this.mensaje = res.data.message;
                        this.url_imprimir = res.data.url_imprimir;
                        this.url_factura = res.data.url_factura;
                        this.url_parcelas = res.data.url_parcelas;
                    }

                }).catch(error => {
                    this.error = error.response.data.message;
                }).finally(() => this.loading = false);
            },
            descuentoConfirmado(descuento){
                this.abonadoLocal.descuento_monedero = descuento;
                this.totalSinDescuentoMonedero = this.total;
                this.total = this.total - descuento;
                this.isDescuentoMonedero =  false;
            },
            cancelarDescuento(){
                this.totalConDescuento(this.abonadoLocal.precio.precio_total_taquilla, this.abonadoLocal.descuento_aplicado != 0 ? this.abonadoLocal.descuento_aplicado: this.abonadoLocal.descuento_integro);
                this.totalSinDescuentoMonedero = 0;
                this.abonadoLocal.descuento_monedero = undefined;
                this.isDescuentoMonedero = false;
            },
            aplicadoDescuento(tipo) {
                switch (tipo) {
                    case 'porcentaje':
                        this.abonadoLocal.descuento_integro = 0;
                        if(this.abonadoLocal.descuento_aplicado === '0') {
                            this.disabled_descuento_integro = false;
                            this.abonadoLocal.descuento_aplicado = 0;
                        } else {
                            this.disabled_descuento_integro = true;
                        }
                        break;
                    case 'integro':
                        this.abonadoLocal.descuento_aplicado = 0;
                        if(this.abonadoLocal.descuento_integro === 0 || this.abonadoLocal.descuento_integro === '0') {
                            this.disabled_descuento_porcentaje = false;
                            this.abonadoLocal.descuento_integro = 0;
                        } else {
                            this.disabled_descuento_porcentaje = true;
                        }
                        break;
                }
            },
            borrarMetodoDePago(metodos_de_pago, id) {
                const metodo_pago_id = metodos_de_pago.findIndex(metodo_de_pago => metodo_de_pago.id === id);

                if (metodo_pago_id !== -1) {
                    metodos_de_pago.splice(metodo_pago_id, 1);
                }
                    
                return metodos_de_pago;
            },
            cambiarAsiento() {
                this.$emit('cambiarAsiento');
            },
            borrarSesionParcelas(cart_id) {
                const params = {
                    cart_id: cart_id,
                };

                this.$store.dispatch(this.config.getVuexAlias('front.parcelas.carrito.borrar'), params).then(res => {
                    this.abonadoLocal.plazas_session_id = null;
                })
            },
            rellenarPais(pais) {
                this.abonadoLocal.pais = pais.nombre;
            }
        },
        components: { SaldoMonederoComponent, DatosLegales, FieldComponent, SeleccionarParcelasComponent, PhoneInput, Paises, Provincias, Locations, checkBoxRenovacion },
    }
</script>

<style scoped>
    .price-large {
        font-size: 40px !important;
        margin-bottom: 4em;
    }
    .price {
        margin-bottom: 4em;
    }
    .espacio {
        justify-content: center;
        align-items: center;
    }
    .my-auto {
        padding-top: 1em;
        padding-bottom: 1em;
        margin-top: 20em;
        font-family: 'Noway';
    }
    hr{
        width: 100%;
        height: 2px;
        margin-top: 1em;
        margin-bottom: 1em;
    }
    @media (max-width: 768px) {
        .price-large {
            font-size: 30px !important;
            margin-left: 0px;
        }
    }
</style>
